export default "__VITE_ASSET__Tk131azZ__"